import { apiV2 } from './api';

export const fetchCreate = (payload) => apiV2.post('/subscriptions/subscription/add-new-card/', payload);
export const fetchDetail = () => apiV2.get('/subscriptions/subscription/products-info-price/');
